// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3ht3s","label":"LabeledBox_label__1Ab5w"};